<template>
  <el-select v-model="id" :size="size" :clearable="clearable" :disabled="disabled" :multiple="multiple" placeholder="请选择班级" :remote-method="remoteMethod" :loading="loading" @change="selectChange">
    <el-option v-for="item in list" :key="item.id" :label="item.name" :value="item.id">
      <span>{{ item.name}}</span>
    </el-option>
  </el-select>
</template>

<script>
export default {
  props: {
    value: "",
    clearable: {
      type: Boolean,
      default: true,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: "small",
    },
    defaultOne: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      list: [],
      id: "",
      loading: false,
    }
  },
  created() {
    this.id = this.value;
  },
  mounted() {
    this.remoteMethod(this.value);
  },
  watch: {
    value: function (newValue) {
      this.id = newValue;
    }
  },
  methods: {
    remoteMethod(query) {
      this.loading = true;
      let params = {
        "name": "",
        "pageIndex": 1,
        "pageSize": 100,
        "state": 1,
      }
      this.list = [];
      this.https("get", "/api/Clazz/GetClazzsByUser", params).then(res => {
        this.loading = false;
        this.list = res.response.data || [];
        if (this.defaultOne && this.list.length > 0) {
          this.id = this.multiple ? [this.list[0].id] : this.list[0].id;
          this.selectChange(this.id);
        }
      }).catch(res => {
        this.loading = false;
      })
    },
    selectChange(val) {
      this.$emit('input', val);
      if (!this.multiple) {
        let obj = this.list.find(item => val == item.id);
        this.$emit('change', obj);
      } else {
        let list = this.list.filter(item => val.indexOf(item.id) >= 0);
        this.$emit('change', list);
      }
    },
  }
}
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/pages/pc/components/shared/ClazzList.vue